export default __webpack_public_path__ + "ad3502c0754717fccdb6e152ecddf951.png";